import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-alarm-category-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div class="flex flex-col justify-start items-start">
        <span class="text-black"> {{ t(type()) }} </span>
        <span class="text-neutral-7"> {{ t(category()) }} </span>
      </div>
    </ng-container>
  `,
})
export class AlarmCategoryIndicatorComponent {
  category = input.required<string>();
  type = input.required<string>();
}
